import { isAffiliate, isPublisher } from '../../../authProvider'
import { PublisherResources } from './PublisherResources'
import { AffiliateResources } from './AffiliateResources'

export const Resources = () => {
  if (isPublisher()) {
    return <PublisherResources />
  } else if (isAffiliate()) {
    return <AffiliateResources />
  }
}
